import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  id: "header"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logo-over"
})], -1);
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<a href=\"/maplestory\"><div class=\"main-site-button\"><div class=\"maple-icon\"><div class=\"maple-icon-over\"></div></div><div class=\"button-text\">Go to Main Site</div></div></a><div class=\"progress-text logged-in\"><div class=\"complete-text\"> COMPLETE! <div class=\"gift\"></div></div></div>", 2);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "points-button button1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "Journey to Override Event")], -1);
const _hoisted_7 = {
  class: "play-free-button button2"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-over"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_router_view = _resolveComponent("router-view");
  const _component_Footer = _resolveComponent("Footer");
  return !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: "/micro-site/override"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _hoisted_4, _createVNode(_component_router_link, {
    to: "/micro-site/override/journey"
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", {
    class: "button-text",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.playFree && $options.playFree(...args))
  }, "Play Free Now")])]), _createVNode(_component_router_view), _createVNode(_component_Footer, {
    color: "#ff6624",
    hoverColor: "#ff9e4f",
    backgroundColor: "#280b17",
    onGoToMainClick: _cache[1] || (_cache[1] = $event => _ctx.clickTracking('Main Site'))
  })])) : _createCommentVNode("", true);
}